import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { FullSpinner } from "@/components/States";

export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const { loginWithToken } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = loc.hash || window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sid) { nav("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google", { session_id: sid });
        await loginWithToken(data.token, data.user);
        window.history.replaceState({}, "", "/app/dashboard");
        nav(data.new_account ? "/app/profile/edit" : "/app/dashboard");
      } catch {
        nav("/login");
      }
    })();
  }, [loc.hash, nav, loginWithToken]);

  return <div className="min-h-screen bg-[#FDFBF7]"><FullSpinner label="Signing you in…" /></div>;
}
